import { Controller } from "@hotwired/stimulus"

// Minimal autosave controller following Rails 8 + Hotwire patterns
// Server-side autosave with Turbo Stream responses
export default class extends Controller {
  static values = { interval: { type: Number, default: 30000 } }
  
  connect() {
    this.startAutosave()
  }
  
  disconnect() {
    this.stopAutosave()
  }
  
  startAutosave() {
    this.autosaveTimer = setInterval(() => {
      if (this.hasUnsavedChanges()) {
        this.performAutosave()
      }
    }, this.intervalValue)
  }
  
  stopAutosave() {
    if (this.autosaveTimer) {
      clearInterval(this.autosaveTimer)
    }
  }
  
  async performAutosave() {
    const form = this.element.querySelector('form')
    if (!form) return
    
    const formData = new FormData(form)
    
    try {
      const response = await fetch(`${form.action}/autosave`, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": this.getCSRFToken(),
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: formData
      })
      
      if (response.ok) {
        const turboStream = await response.text()
        Turbo.renderStreamMessage(turboStream)
        this.markAsSaved()
      }
    } catch (error) {
      console.error("Autosave failed:", error)
    }
  }
  
  hasUnsavedChanges() {
    return this.element.dataset.hasUnsavedChanges === "true"
  }
  
  markAsSaved() {
    this.element.dataset.hasUnsavedChanges = "false"
  }
  
  // Mark form as having unsaved changes when user types
  markAsChanged() {
    this.element.dataset.hasUnsavedChanges = "true"
  }
  
  getCSRFToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}